module.exports = __webpack_public_path__ + "img/client12.aa494c76.svg";